import React, { useCallback } from "react";
import { connect } from "react-redux";

import useDebouncedCallback from "@mapmycustomers/shared/util/hook/useDebouncedCallback";
import { SearchField } from "@mapmycustomers/ui";

import { getViewState } from "@app/scene/settings/component/ManageFields/store";
import { updateViewState } from "@app/scene/settings/component/ManageFields/store/actions";
import { RootState } from "@app/store/rootReducer";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import styles from "./SearchBox.module.scss";

interface Props {
  analyticIssuer?: AnalyticsService;
  placeholder?: string;
  search?: string;
  updateViewState: typeof updateViewState;
}

const SearchBox: React.FC<Props> = ({ analyticIssuer, placeholder, updateViewState }) => {
  const handleSearch = useCallback(
    (query: string) => {
      analyticIssuer?.clicked(["Search Fields"]);
      updateViewState({
        search: query,
      });
    },
    [analyticIssuer, updateViewState]
  );

  const handleChange = useDebouncedCallback(
    [handleSearch, 500, { trailing: true }],
    [handleSearch]
  );

  return (
    <div className={styles.container}>
      <SearchField allowClear onChange={handleChange} placeholder={placeholder} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  search: getViewState(state).search ?? "",
});

const mapDispatchToProps = {
  updateViewState,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);
